import React from "react";
import Button from "../../../../components/button/button";
import { ClassENADModal } from "../../../GenericTeacherProfile";
import classNames from "classnames";

const ClassProfileBubbleContent = ({
  selectedClassProfile,
  classProfileList,
  handleSelectClassProfile,
  handleCreateGroup,
}) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4">
        <div>¡Hola!</div>
        <div>
          ¿Estas listo para planear tu sesión ENAd? Para empezar, bríndame la
          siguiente información.
        </div>
        <div>Selecciona el grupo con el que trabajaremos.</div>
      </div>
      <div
        className={classNames("flex flex-wrap gap-2", {
          "": classProfileList.length > 4,
        })}
      >
        {classProfileList
          .filter((e) => e.student_level)
          .map((cp, i) => (
            <label
              key={i}
              className={classNames(
                "bg-DarkBlue-500 py-2 px-4 rounded cursor-pointer flex flex-row  gap-4 text-3.5 items-center ",
                {
                  "bg-opacity-40":
                    selectedClassProfile?.class_name !== cp.class_name,
                }
              )}
              onClick={() => handleSelectClassProfile(cp)}
            >
              {cp.class_name}

              <span
                className={`${
                  selectedClassProfile?.class_name === cp.class_name
                    ? "text-Yellow-500"
                    : "text-Grey-500/50"
                }`}
              >
                &#x2714;
              </span>
            </label>
          ))}
        <ClassENADModal
          onGroupCreated={handleCreateGroup}
          className="fixed inset-0 m-auto"
          textButton="create_group_plus"
          ButtonOpen={(props) => <Button {...props} />}
        />
      </div>
    </div>
  );
};

export default ClassProfileBubbleContent;
